class SearchTemplate extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      blankTemplate: "#newspaper-results-blank",
      template: "#newspaper-results-template",
      container: "#newspaper-results-container",
      imageContainer: "[data-newspaper-image]",
      image: "#image-newspaper",
      heading: "[data-heading-text]",
      price: "[data-price]",
      button_url: "[data-button-url]",
      data_qty_text: "[data-qty-text]",
    };
    this.handleSelectClick = this.handleSelectClick.bind(this);
  }

  connectedCallback() {
    console.log(this.querySelector(this.selectors.blankTemplate));
    this.elements = {
      cardTemplate: this.querySelector(this.selectors.template),
      container: this.querySelector(this.selectors.container),
      blankTemplate: this.querySelector(this.selectors.blankTemplate),
    };
  }

  handleSelectClick(event, newspaperData) {
    event.preventDefault();

    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }

    const state = {
      name: newspaperData.name,
      price: newspaperData.price,
      image_url: newspaperData.image_url,
      newspaper_date: newspaperData.newspaper_date,
      newspaper_origin: newspaperData.newspaper_origin,
      newspaper_rate: newspaperData.newspaper_rate,
      newspaper_currency: newspaperData.newspaper_currency,
      newspaper_id: newspaperData.newspaper_id,
      qty: newspaperData.qty,
      media_code: newspaperData.media_code,
    };

    const newUrl = Shopify.routes.root + `products/original-newspapers`;
    history.pushState(state, "", newUrl);
    window.location.reload();
  }

  createCard(data) {
    const clone = this.elements.cardTemplate.content.cloneNode(true);
    const image = clone.querySelector(this.selectors.image);

    if (data.image_url) {
      image.src = data.image_url;
      image.alt = data.name;
    } else {
      image.alt = "No image available";
    }

    clone.querySelector(this.selectors.heading).textContent = data.name;
    clone.querySelector(this.selectors.price).textContent =
      `From ${Shopify.formatMoney(data.price, "{{amount}}")} ${Shopify.currency.active}`;
    const button = clone.querySelector(this.selectors.button_url);

    button.addEventListener("click", (e) => this.handleSelectClick(e, data));

    const qtyMessageDiv = clone.querySelector(this.selectors.data_qty_text);
    if (data.qty === 1) {
      qtyMessageDiv.textContent = "Last one";
      qtyMessageDiv.style.display = "block";
      qtyMessageDiv.classList.add("bg-royal-red");
    } else if (data.qty < 4) {
      qtyMessageDiv.textContent = `Only ${data.qty} left`;
      qtyMessageDiv.style.display = "block";
      qtyMessageDiv.classList.add("bg-royal-red");
    } else {
      qtyMessageDiv.style.display = "none";
    }

    return clone;
  }

  renderResults(newspapers) {
    console.log(newspapers);
    if (newspapers.length < 1) {
      this.elements.blankTemplate.classList.remove("hidden");
      this.elements.blankTemplate.classList.add("flex");
      if (this.elements.container.classList.contains("!grid")) {
        this.elements.container.classList.remove("!grid");
        this.elements.container.innerHTML = "";
      }
    } else {
      this.elements.blankTemplate.classList.add("hidden");
      this.elements.container.classList.add("!grid");
      this.elements.container.innerHTML = "";
      newspapers.forEach((newspaper) => {
        const card = this.createCard(newspaper);
        this.elements.container.appendChild(card);
      });
    }
  }

  disconnectedCallback() {}
}

customElements.define("search-template", SearchTemplate);
